/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

import {APIService} from '@/core/util/services/api.service';

// shims-vue.d.ts dichiara `appGlobal` solo per i file .vue: nei .ts va riletto qui.
const baseUrl = (): string =>
  (window as unknown as {appGlobal: {baseUrl: string}}).appGlobal.baseUrl;

/** Servizio per un percorso di `/api/v2/expensa`, per esempio `/reports`. */
export const expensaApi = (path: string): APIService =>
  new APIService(baseUrl(), '/api/v2/expensa' + path);

/** Indirizzo di una pagina del back-office: `/expensa/<azione>[/<id>]`. */
export const pageUrl = (action: string, id?: number): string =>
  `${baseUrl()}/expensa/${action}${id ? '/' + id : ''}`;

/**
 * `fileUrl` e `thumbUrl` delle API sono relativi a `/web/index.php`, che è
 * proprio il `baseUrl` della pagina.
 */
export const fileUrl = (relative: string): string => `${baseUrl()}${relative}`;

/** Il messaggio d'errore dell'API (`{error: {message}}`), o un testo generico. */
export const errorMessage = (e: unknown): string => {
  const message = (e as {response?: {data?: {error?: {message?: unknown}}}})
    ?.response?.data?.error?.message;
  return typeof message === 'string' && message !== ''
    ? message
    : 'Operazione non riuscita';
};
